import React from 'react'
import PropTypes from 'prop-types'
import { isObservable, observe } from 'mobx'
import { observer } from 'mobx-react'
import { useCollection } from './hooks'
import { getMapValue } from '@morningtrain/react-helpers'

function SortBy (props) {
  const collection = useCollection()
  const { children, by, type } = props
  const to_return = props.direction === 'asc' ? -1 : 1

  React.useEffect(() => {
    let disposer = null

    if (isObservable(collection)) {
      disposer = observe(collection, () => {
        const sortedCollection = collection.sort((a, b) => {
          let a_val = getMapValue(a, by)
          let b_val = getMapValue(b, by)

          const evalType = type || typeof a_val

          if (evalType === 'boolean') {
            if (a_val === b_val) return 0
            if (a_val) return to_return
            if (b_val) return -to_return
          }
          if (evalType === 'number') {
            if (a_val < b_val) return to_return
            if (a_val > b_val) return -to_return

            return 0
          }

          if (typeof (a_val) === 'undefined' || a_val === null) a_val = ''
          if (typeof (b_val) === 'undefined' || b_val === null) b_val = ''

          return a_val.localeCompare(b_val, 'da') * -to_return
        })

        if (JSON.stringify(sortedCollection) !== JSON.stringify(collection)) {
          collection.replace(sortedCollection)
        }
      }, true)
    }

    return () => {
      if (typeof disposer === 'function') {
        disposer()
      }
    }
  }, [])

  return (
    <>
      {children}
    </>
  )
}

SortBy.defaultProps = {
  by: null,
  type: null,
  direction: 'asc'
}

SortBy.propTypes = {
  by: PropTypes.string.isRequired,
  type: PropTypes.string,
  direction: PropTypes.oneOf(['asc', 'desc'])
}

export default observer(SortBy)
